import { getLang } from "helpers/themeHelpers";
import { useTheme } from "styled-components";

export const linkToSupport = () => {
  const locale = getLang();
  return `/${locale}/${locale === "ar" ? "مساعدة" : "support"}`;
};

export const linkToContactUs = () => {
  const locale = getLang();
  const part = locale === "ar" ? "مساعدة/اتصل-بنا" : "support/contact-us";
  return `/${locale}/${part}`;
};

export const linkToFAQcategory = (faqCategory) => {
  const locale = getLang();
  const part =
    locale === "ar" ? `مساعدة/${faqCategory}` : `support/${faqCategory}`;
  return `/${locale}/${part}`;
};

export const linkToThanks = () => {
  const locale = getLang();
  const part = `${locale === "ar" ? "مساعدة/شكرا" : "support/thankyou"}`;
  return `/${locale}/${part}`;
};
